import React, { useState, useEffect, useMemo } from "react";
import { Form } from "react-bootstrap";
import { Button, ButtonType } from "../../../Components";
import { ButtonFrameworkVariant } from "../../../Components/ButtonFramework";
import * as R from "ramda";
import { DROPDOWN_BTN, SEARCH_MENU } from "../../MetaBuyingConstants";

interface TargetingMenuProps {
  placeholder: string;
  menuId: string;
  closeMenu: () => void;
  showMenu: boolean;
  applySelections: (value: Record<string, any>[]) => void;
  appliedSelections: Record<string, any>[];
  data: { id: string; name: string }[];
  title?: string;
}

export const TargetingMenu = ({
  placeholder,
  menuId,
  closeMenu,
  showMenu,
  applySelections,
  appliedSelections,
  data,
  title,
}: TargetingMenuProps): JSX.Element => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTargets, setSelectedTargets] = useState<Record<string, any>[]>([]);

  const dropdownBtnId = [menuId, DROPDOWN_BTN].join("_");
  const searchMenuId = [menuId, SEARCH_MENU].join("_");

  useEffect(() => {
    setSelectedTargets(R.clone(appliedSelections));
  }, [showMenu, appliedSelections]);

  const selectedIds: string[] = useMemo(() => selectedTargets.map(({ id }) => id), [
    selectedTargets,
  ]);

  return (
    <div id={dropdownBtnId} className="metaBuyingSearchMenu menuToggle">
      <div className="title">{title}</div>
      <Button className="dropdown-toggle" type={ButtonType.OUTLINED}>
        {appliedSelections.length > 0 ? (
          appliedSelections.map(({ name }, index) => (
            <div
              key={index}
              className="appliedSelection"
              onClick={() => {
                const newAppliedSelections = R.remove(index, 1, appliedSelections);
                applySelections(newAppliedSelections);
                setSelectedTargets(newAppliedSelections);
                closeMenu();
              }}
            >
              <span>{name}</span>
            </div>
          ))
        ) : (
          <span className="searchMenuPlaceholder">{placeholder}</span>
        )}
      </Button>
      {showMenu && (
        <div id={searchMenuId} className="searchMenu menuToggle">
          {" "}
          <div>
            <Form.Control
              size="sm"
              className="searchBar"
              placeholder="Search"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            <div className="searchMenuRows">
              {data.map((option, index) => (
                <div key={index} className="searchMenuRow">
                  <Form.Check
                    className="searchMenuOption"
                    key={index}
                    type="checkbox"
                    label={<div>{option.name}</div>}
                    checked={R.includes(option.id, selectedIds)}
                    id={option.name}
                    onChange={() =>
                      setSelectedTargets(
                        R.includes(option.id, selectedIds)
                          ? selectedTargets.filter(({ id }) => id !== option.id)
                          : [...selectedTargets, option]
                      )
                    }
                  />
                </div>
              ))}
            </div>
            <div className="searchMenuControls">
              <Button
                type={ButtonType.OUTLINED}
                variant={ButtonFrameworkVariant.NO_ICON}
                onClick={closeMenu}
              >
                Cancel
              </Button>
              <Button
                disabled={R.isEmpty(selectedIds)}
                type={ButtonType.FILLED}
                variant={ButtonFrameworkVariant.NO_ICON}
                onClick={() => {
                  applySelections(selectedTargets);
                  closeMenu();
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
